import * as React from 'react'
import useTheme from '@eversports/klimt-design-components/use-theme'
import useMediaQuery from '@eversports/klimt-design-components/use-media-query'
import Dialog, { DialogContent } from '@eversports/klimt-primitives/Dialog'

import Drawer from '../../../../../../components/Drawer'

import ProfileVisibilityContent from './ProfileVisibilityContent'

interface Props {
  isOpen: boolean
  toggleDialog: () => void
}

const ProfileVisibility = ({ isOpen, toggleDialog }: Props) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  return isMobile ? (
    <Drawer open={isOpen} onClose={toggleDialog}>
      <ProfileVisibilityContent onClose={toggleDialog} />
    </Drawer>
  ) : (
    <Dialog open={isOpen} onClose={toggleDialog} maxWidth="xs">
      <DialogContent>
        <ProfileVisibilityContent onClose={toggleDialog} />
      </DialogContent>
    </Dialog>
  )
}

export default ProfileVisibility
